import React, { useState, useEffect, Fragment } from "react";
import {
  TabPane,
  Button,
  Row,
  Col,
  Input,
  Collapse,
} from "reactstrap";
import "./index.css";
import ApiCaller from "../../../../api/apiCaller";
import LegalFile from "../LegalFile";
import Lightbox from "react-image-lightbox";
import t from "utils/Lang";

interface LegalDocumentTabProps {
  isView: boolean;
  siteData: any;
  setSiteData: Function;
  selectedPhotos: any;
  setSelectedPhotos: Function;
  onImageRemoved?: Function;
  onExistingAttachmentsUpdated?: Function;
}

export default function LegalDocumentTab({
  isView,
  siteData,
  setSiteData,
  selectedPhotos,
  setSelectedPhotos,
  onImageRemoved,
  onExistingAttachmentsUpdated,
}: LegalDocumentTabProps) {
  const randomString = Math.random().toString(36).substring(7);
  const fileInputId = `${Date.now().toString()}-${randomString}`;

  const [attachmentToUploads, setAttachmentToUploads] =
    useState<Array<any> | null>([]);
  const [legalDocumentTypes, setLegalDocumentTypes] =
    useState<Array<any> | null>([]);
  const [isShowTemplate, setIsShowTemplate] = useState<boolean>(false);
  const [documentTemplates, setDocumentTemplates] = useState<Array<any> | null>(
    []
  );
  const [currentUser, setCurrentUser] = useState<any>(null);

  const [imageBoxState, setImageBoxState] = useState({
    showLightBox: false,
    photoIndex: 0,
  });

  const updateAttachmentToUpload = (attachmentToUpdate: any) => {
    const newAttachmentToUpload = attachmentToUploads;
    newAttachmentToUpload?.forEach((attachment: any, index: number) => {
      if (attachment.url === attachmentToUpdate.url) {
        newAttachmentToUpload[index] = attachmentToUpdate;
      }
    });
    setAttachmentToUploads(newAttachmentToUpload);
    setSelectedPhotos(newAttachmentToUpload);
  };
  const deleteAttachmentToUpload = (url: string) => {
    if (attachmentToUploads) {
      setAttachmentToUploads(
        attachmentToUploads.filter((attachment) => attachment.url != url)
      );
    }
  };

  const toogleTemplateDownload = () => {
    setIsShowTemplate(!isShowTemplate);
    getTemplates();
  };
  const getTemplates = async () => {
    const uri = `document_template/site/legal_document/list`;
    const res = await ApiCaller.get(uri);
    if (res?.result) {
      setDocumentTemplates(res?.result);
    }
  };
  const downloadTemplateFile = (fileUrl: string) => {
    window.open(fileUrl, "_blank");
  };

  const getCurrentUser = async () => {
    const res = await ApiCaller.get("userme/me");
    if (res?.result) {
      setCurrentUser(res?.result);
    } else {
      console.log(res);
    }
  };

  const updateExistingAttachment = (attachmentToUpdate: any) => {
    const existingAttachments = siteData.data.attachments;
    existingAttachments?.forEach((attachment: any, index: number) => {
      if (attachment.id === attachmentToUpdate.id) {
        existingAttachments[index] = attachmentToUpdate;
      }
    });
    if (onExistingAttachmentsUpdated) {
      onExistingAttachmentsUpdated(existingAttachments);
    }
  };
  const deleteExistingAttachment = async (attachmentToDelete: any) => {
    const confirmationBox = window.confirm(t().site_photo_tab__delete_photo);
    if (!confirmationBox) return;
    const uri = `file_attachment/${attachmentToDelete.id}/delete`;
    const res = await ApiCaller.delete(uri);
    if (res.status === "ok") {
      const currentSiteData = siteData;
      setSiteData({
        ...currentSiteData,
        data: {
          ...currentSiteData.data,
          attachments: currentSiteData.data.attachments.filter(
            (attachment: any) => attachment.id != attachmentToDelete.id
          ),
        },
      });
    } else {
      alert(res.msg);
    }
  };

  const attachFileButtonClick = () => {
    if (document.getElementById(fileInputId)) {
      document?.getElementById(fileInputId)?.click();
    }
  };

  const selectImagesToUpload = (event: any) => {
    const filesArray = Array.from(event.target.files);
    const newAttachmentToUploads = filesArray.map((file: any) => {
      return {
        blob: file,
        url: URL.createObjectURL(file),
      };
    });
    let attachmentData = [];
    if (attachmentToUploads) {
      attachmentData = [...attachmentToUploads, ...newAttachmentToUploads];
    } else {
      attachmentData = [...newAttachmentToUploads];
    }
    setAttachmentToUploads(attachmentData);
    setSelectedPhotos(attachmentData);
  };

  const onImageClick = (imageUrl: any, imageArray: any) => {
    imageArray.map((url: string, idx: any) => {
      if (url === imageUrl) {
        setImageBoxState({
          showLightBox: true,
          photoIndex: idx,
        });
      }
    });
  };

  const getLegalDocumentTypes = async () => {
    const uri = `legal_document_type/`;
    const res = await ApiCaller.get(uri);
    if (res.result) {
      setLegalDocumentTypes(res.result);
    }
  };

  useEffect(() => {
    getLegalDocumentTypes();
    getCurrentUser();
  }, []);

  let images: any = [];
  let imageTitles: any = [];
  let imageCaptions: any = [];
  if (siteData?.data?.attachments) {
    const imageArray = siteData?.data?.attachments?.filter(
      (attachment: any) => attachment.file_type === "image"
    );
    images = imageArray.map((attachment: any) => attachment.file_url);
    imageTitles = imageArray.map((attachment: any) => attachment.file_name);
    imageCaptions = imageArray.map(
      (attachment: any) => attachment.caption_text
    );
  }
  return (
    <TabPane tabId="site_legal_document_tab">
      {!isView && (
        <Row>
          <Col xs={12} sm={6}>
            <div style={styles.actionSheet}>
              <Button
                outline
                color="primary"
                onClick={attachFileButtonClick}
                style={styles.commentButton}
              >
                {t().site_photo_tab__insert_photo}
              </Button>
              <Input
                type="file"
                label={t().site_photo_tab__select_file}
                title=""
                id={fileInputId}
                multiple
                hidden
                style={styles.selectFileButton}
                onChange={(e) => selectImagesToUpload(e)}
                key={fileInputId}
              />
            </div>
          </Col>
          <Fragment>
            <Col xs={12} sm={6}>
              <div style={styles.actionSheet}>
                <Button
                  outline
                  color="primary"
                  onClick={toogleTemplateDownload}
                  style={styles.commentButton}
                >
                  {t().site_legal_document__download_template}
                </Button>
              </div>
            </Col>
            <Col xs={12}>
              <Collapse isOpen={isShowTemplate}>
                <div style={styles.templateFilesContainer}>
                  {documentTemplates &&
                    documentTemplates.map((documentTemplate) => (
                      <div
                        id={documentTemplate.id}
                        onClick={() =>
                          downloadTemplateFile(documentTemplate.file_url)
                        }
                        style={styles.templateFileName}
                        key={documentTemplate.id}
                      >
                        <i
                          className="material-icons"
                          style={styles.templateFileIcon}
                        >
                          attach_email
                        </i>
                        <span>{documentTemplate.name}</span>
                      </div>
                    ))}
                </div>
              </Collapse>
            </Col>
          </Fragment>
        </Row>
      )}
      <Row style={styles.attachmentContainer}>
        {attachmentToUploads && attachmentToUploads.length > 0 && (
          <Fragment>
            {attachmentToUploads.map((attachment, index) => (
              <Col xs={12} sm={6} key={index}>
                <div style={styles.attachmentWrapper}>
                  <LegalFile
                    key={`attachment-index-${index}`}
                    legalDocumentTypes={legalDocumentTypes}
                    isView={isView}
                    attachment={attachment}
                    onAttachmentToUploadDeleted={(attachment: any) =>
                      deleteAttachmentToUpload(attachment.url)
                    }
                    onAttachmentUpdated={(attachmentAfterUpdated: any) =>
                      updateAttachmentToUpload(attachmentAfterUpdated)
                    }
                  />
                </div>
              </Col>
            ))}
          </Fragment>
        )}
        {siteData?.data?.attachments?.map((attachment: any) => {
          // Only show legal document files on this tab
          if (attachment.attachment_content_relation_type !== "legal_document")
            return null;
          return (
            <Col xs={12} sm={6} key={`${attachment.id}`}>
              <div style={styles.attachmentWrapper}>
                <LegalFile
                  legalDocumentTypes={legalDocumentTypes}
                  isView={isView}
                  attachment={attachment}
                  isExistingAttachment
                  onAttachmentUpdated={(attachmentAfterUpdated: any) =>
                    updateExistingAttachment(attachmentAfterUpdated)
                  }
                  onExistingAttachmentDeleted={(attachment: any) =>
                    deleteExistingAttachment(attachment)
                  }
                  onImageClick={(attachment: any) =>
                    onImageClick(attachment.file_url, images)
                  }
                />
              </div>
            </Col>
          );
        })}
      </Row>
      {imageBoxState?.showLightBox && (
        <Lightbox
          mainSrc={images[imageBoxState?.photoIndex]}
          nextSrc={images[(imageBoxState?.photoIndex + 1) % images.length]}
          prevSrc={
            images[
              (imageBoxState?.photoIndex + images.length - 1) % images.length
            ]
          }
          onCloseRequest={() =>
            setImageBoxState({ ...imageBoxState, ...{ showLightBox: false } })
          }
          onMovePrevRequest={() =>
            setImageBoxState({
              ...imageBoxState,
              ...{
                photoIndex:
                  (imageBoxState?.photoIndex + images.length - 1) %
                  images.length,
              },
            })
          }
          onMoveNextRequest={() =>
            setImageBoxState({
              ...imageBoxState,
              ...{
                photoIndex: (imageBoxState?.photoIndex + 1) % images.length,
              },
            })
          }
          imageTitle={imageTitles[imageBoxState?.photoIndex]}
          imageCaption={imageCaptions[imageBoxState?.photoIndex]}
        />
      )}
    </TabPane>
  );
}

const styles = {
  customTextInput: {
    marginTop: 20,
  },
  imageContainer: {},
  imageNote: {
    marginTop: 12,
  },
  commentButtonContainer: {
    backgroundColor: "var(--color-line-light)",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 6,
    paddingRight: 3,
    paddingBottom: 3,
  } as React.CSSProperties,
  commentButton: {
    marginLeft: 6,
  },
  selectFileButton: {},
  imageAttachment: {
    width: 180,
    height: 180,
    borderRadius: 6,
    marginRight: 12,
    marginBottom: 12,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    position: "relative",
    backgroundColor: "var(--color-line)",
    border: "1px solid var(--color-line)",
  } as React.CSSProperties,
  imageAttachmentDeleteButton: {
    fontSize: 12,
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "none",
    backgroundColor: "var(--color-muted)",
    color: "var(--color-white)",
    position: "absolute",
    top: 4,
    right: 4,
  } as React.CSSProperties,
  generalFileAttachmentDeleteButton: {
    fontSize: 12,
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "none",
    backgroundColor: "var(--color-muted)",
    color: "var(--color-white)",
    marginLeft: 16,
  },
  fileAttachment: {
    marginRight: 12,
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 3,
    padding: "6px 12px",
    backgroundColor: "var(--color-line)",
  },
  actionSheet: {
    marginTop: 24,
    marginBottom: 24,
  },
  attachmentContainer: {
    marginBottom: 48,
    marginTop: 24,
  },
  attachmentWrapper: {
    marginBottom: 24,
  },
  templateFilesContainer: {
    padding: 12,
    borderRadius: 4,
    border: "1px solid var(--color-line)",
  },
  templateFileIcon: {
    marginRight: 6,
  },
  templateFileName: {
    color: "var(--color-accent-dark)",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    marginBottom: 6,
  },
};
